import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAttractionsDetails, IAttractionsInitialState } from "./attractionsModal";
import {
  ActiveInactiveAttractions, AttractionsImageUpload, createAttractions,
  deleteAttractions, getAllActiveAttractions, getAllAttractions, getAttractionsByID,
  getAttractionsByURL, updateAttractions,
} from "./attractions.services";

const blankDetail: IAttractionsDetails = {
  ID: null, Title: "", AttractionURL: "", AttractionCategory: "", TagLine: "",
  Distance: "", TravelTime: "", BestTime: "", Duration: "", Description: "",
  Dos: "", Donts: "", MainImage: "", BannerImage: "", MetaTitle: "", MetaDescription: "",
  MetaKeywords: "", IsActive: 1, BestTimes: [], HowToReach: [], ThingsToDo: [],
  WhyVisit: [], Nearby: [], Images: [],
};

const initialState: IAttractionsInitialState = {
  loading: false, formLoading: false, error: "", AttractionsID: null,
  AttractionsList: [], AttractionsDetail: blankDetail,
};

const attractionsSlice = createSlice({
  name: "attractions",
  initialState,
  reducers: {
    clearAttractionsDetails: (state) => { state.AttractionsDetail = initialState.AttractionsDetail; },
    setAttractionsID: (state, action) => { state.AttractionsID = action.payload; },
    clearAttractionsID: (state) => { state.AttractionsID = initialState.AttractionsID; },
  },
  extraReducers: (builder) => {
    [getAllAttractions, getAllActiveAttractions].forEach((thunk) => {
      builder.addCase(thunk.pending, (state) => { state.loading = true; state.error = ""; });
      builder.addCase(thunk.fulfilled, (state, action: PayloadAction<IAttractionsDetails[]>) => {
        state.loading = false; state.AttractionsList = action.payload || [];
      });
      builder.addCase(thunk.rejected, (state, action) => {
        state.loading = false; state.error = action.error.message || "Something went wrong"; state.AttractionsList = [];
      });
    });
    [createAttractions, updateAttractions, deleteAttractions, ActiveInactiveAttractions, AttractionsImageUpload].forEach((thunk) => {
      builder.addCase(thunk.pending, (state) => { state.loading = true; state.error = ""; });
      builder.addCase(thunk.fulfilled, (state) => { state.loading = false; });
      builder.addCase(thunk.rejected, (state, action) => { state.loading = false; state.error = action.error.message || "Something went wrong"; });
    });
    [getAttractionsByID, getAttractionsByURL].forEach((thunk) => {
      builder.addCase(thunk.pending, (state) => { state.loading = true; state.error = ""; });
      builder.addCase(thunk.fulfilled, (state, action: PayloadAction<IAttractionsDetails>) => {
        state.loading = false; state.AttractionsDetail = action.payload;
      });
      builder.addCase(thunk.rejected, (state, action) => {
        state.loading = false; state.AttractionsDetail = initialState.AttractionsDetail;
        state.error = action.error.message || "Something went wrong";
      });
    });
  },
});

export const { clearAttractionsDetails, clearAttractionsID, setAttractionsID } = attractionsSlice.actions;
export default attractionsSlice.reducer;
